import {types, getParent} from "mobx-state-tree"

// types.maybe(types.optional(Foo, {}))

const Paginate = types.model({
  total_records: types.optional(types.number, 0),
  current_page: types.optional(types.number, 0),
  page_count: types.optional(types.number, 0),
  prev_page: types.maybe(types.optional(types.number, 0)), //PaginateObject return nulls but it doesn't work
  next_page: types.maybe(types.optional(types.number, 0)), //PaginateObject return nulls but it doesn't work
  show: types.optional(types.boolean, false),
  show_prev: types.optional(types.boolean, false),
  show_next: types.optional(types.boolean, false),
}).actions(self => ({

    to_next_page() {
      getParent(self).go_to_page(self.next_page)
    },

    to_prev_page() {
      getParent(self).go_to_page(self.prev_page)
    },

    to_page(p) {
      getParent(self).go_to_page(p)
    }
  })
)


export default Paginate

